module.exports = __webpack_public_path__ + "img/slide6.689a4133.jpg";